import React, { useEffect, useState } from "react";
import "./Header.css";
import { Link, useLocation } from "react-router-dom";
import { Nav, Navbar } from "react-bootstrap";
import Book_appointment_modal from "../common-components/common-modals/book-appointment-modal/Book_appointment_modal";
import Search_product_offcanvas from "../common-components/common-offcanvas/search-offcanvas/Search_product_offcanvas";
import { useDispatch, useSelector } from "react-redux";
import { getUserInfo } from "../../features/user/userSlice";
import { getAllProducts } from "../../features/products/productsSlice";

function Header({ filters, handleFilterChange }) {
  const dispatch = useDispatch();
  const [modalShow, setModalShow] = useState(false);
  const [searchoffcanvas, setSearchOffcanvas] = useState(false);
  const [expanded, setExpanded] = useState(false);

  const location = useLocation();
  const topframes = useSelector((state) => state.product.allProducts);
 
  useEffect(() => {
    dispatch(getAllProducts());
  }, [dispatch]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const is_signin = useSelector((state) => state.auth.is_signin);
  const user = useSelector((state) => state.user.userInfo);

  useEffect(() => {
    if (is_signin) {
      dispatch(getUserInfo());
    }
  }, [is_signin, dispatch]);

  return (
    <section className="header_main">
      <Navbar
        expand="lg"
        expanded={expanded}
        onToggle={() => setExpanded(!expanded)}
      >
        <div className="container-xl">
          <Navbar.Brand>
            <Link to="/" onClick={() => setExpanded(false)}>
              <img
                className="head_logo"
                src={process.env.PUBLIC_URL + "/assets/images/logo/logo.png"}
                alt="logo"
              />
            </Link>
          </Navbar.Brand>

          <Navbar.Toggle aria-controls="basic-navbar-nav" />

          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto">
              <Nav.Link
                onClick={() => setExpanded(false)}
                as={Link}
                to="/all-products"
                className={
                  location.pathname === "/all-products" ? "active" : ""
                }
              >
                Collection
              </Nav.Link>
              <Nav.Link
                onClick={() => setExpanded(false)}
                as={Link}
                to="/eye-q"
                className={location.pathname === "/eye-q" ? "active" : ""}
              >
                EyeQ
              </Nav.Link>
              <Nav.Link
                onClick={() => setExpanded(false)}
                as={Link}
                to="/bapat-benefits" // Fixed typo
                className={
                  location.pathname === "/bapat-benefits" ? "active" : ""
                }
              >
                Bapat Benefits
              </Nav.Link>
              <Nav.Link
                onClick={() => setExpanded(false)}
                as={Link}
                to="/quick-quiz"
                className={location.pathname === "/quick-quiz" ? "active" : ""}
              >
                Quick Quiz
              </Nav.Link>
              {/* {is_signin ? ( */}
                <Nav.Link
                  as={Link}
                  onClick={() => setModalShow(true)}
                  className={location.pathname === "/" ? "active" : ""}
                >
                  Book an Appointment
                </Nav.Link>
              {/* ) : (
                <Nav.Link
                  as={Link}
                  to="/login"
                  className={location.pathname === "/" ? "active" : ""}
                >
                  Book an Appointment
                </Nav.Link>
              )} */}
            </Nav>
          </Navbar.Collapse>

          <div className="profilesec">
            <Nav.Link
              onClick={() => setSearchOffcanvas(true)}
              className={location.pathname === "/" ? "active" : ""}
            >
              <img
                className="proficn"
                src={process.env.PUBLIC_URL + "/assets/images/icons/search.png"}
                alt="search"
              />
            </Nav.Link>
            <Nav.Link
              as={Link}
              to="/cart"
              className={location.pathname === "/cart" ? "active" : ""}
            >
              <img
                className="proficn"
                src={process.env.PUBLIC_URL + "/assets/images/icons/cart.png"}
                alt="cart"
              />
            </Nav.Link>
            <Nav.Link
              as={Link}
              to="/wishlist"
              className={location.pathname === "/wishlist" ? "active" : ""}
            >
              <img
                className="proficn"
                src={
                  process.env.PUBLIC_URL + "/assets/images/icons/wishlist.png"
                }
                alt="wishlist"
              />
              <span className="wisp">Wishlist</span>
            </Nav.Link>
            <Nav.Link
              as={Link}
              to={is_signin ? "/my-account" : "/login"}
              className="profilenav"
            >
              <img
                className="proficn"
                src={
                  process.env.PUBLIC_URL + "/assets/images/icons/profile.png"
                }
                alt="profile"
              />
              <span className="username">
                {is_signin ? user?.name || "User" : "Sign In"}
              </span>
            </Nav.Link>
          </div>
        </div>
      </Navbar>

      <Book_appointment_modal
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
      <Search_product_offcanvas
        show={searchoffcanvas}
        onHide={() => setSearchOffcanvas(false)}
        filters={filters}
        onFilterChange={handleFilterChange}
      />
    </section>
  );
}

export default Header;
